import React, { FC, useRef } from 'react';
import CustomInput from '../../../common/CustomInput';
import CapacityFormOutboundFields from '../CapacityFormOutboundFields';
import useTranslation from '../../../hooks/useTranslation';
import CustomSelect from '../../../common/CustomSelect';
import { getOptionsFromTranslation } from '../../../utils/utils';
import InlineMessage from '@ingka/inline-message';
import { useFormContext } from 'react-hook-form';
import { ESTABLISHMENT_TYPE } from '../../ProjectTypeSelect/utils';
import CustomAutocomplete from '../../CustomAutocomplete';
import { selectBUs } from '../../../store/selectData/selectors';
import { useTypedSelector } from '../../../store';

type ProjectCapacityFormProps = {
  tabType: ESTABLISHMENT_TYPE;
};

const ProjectCapacityForm: FC<ProjectCapacityFormProps> = ({ tabType }) => {
  const t = useTranslation();
  const { watch } = useFormContext();
  const unitCategory = watch('unitCategory');
  const allBUs = useTypedSelector(selectBUs);

  const showReplenishmentUnit =
    tabType === ESTABLISHMENT_TYPE.NEW_UNIT && unitCategory === 'CMP';
  const isep = watch('isep');
  const replenishmentUnit = watch('replenishmentUnit');
  const initialReplenishmentUnit = useRef(replenishmentUnit);

  return (
    <>
      {showReplenishmentUnit && (
        <CustomAutocomplete
          optionsArray={allBUs}
          name={'replenishmentUnit'}
          label={t('labels.replenishmentUnit')}
          disabled={!!isep && !!initialReplenishmentUnit.current}
        />
      )}
      <InlineMessage
        body={t('flight.createSubmissionModal.capacity_info')}
        variant={'cautionary'}
      />
      <CustomInput
        dataTestID={'inbound-stocked-range'}
        name={'stockedRangeAdjustment'}
        type={'number'}
        label={t('labels.inboundStockedRange')}
      />
      <CustomInput
        dataTestID={'inbound-storage-capacity'}
        name={'storageCapacityAdjustment'}
        type={'number'}
        label={t('labels.inboundStorageCapacity')}
      />
      <CapacityFormOutboundFields />
      <CustomSelect
        dataTestID={'automation-level-select'}
        optionsArray={getOptionsFromTranslation(t, 'automationLevel')}
        name={'automationLevel'}
        label={t('labels.automationLevel')}
      />
    </>
  );
};

export default ProjectCapacityForm;
